const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7398,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_12",
    transform: "matrix(1,0,0,1,7398.1,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(132,99,164)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7406.39,14.1443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7642.62,403.418C7657.97,398.769 7669.36,385.843 7672.06,370.036C7689.13,267.42 7771.58,183.579 7880.01,169.562C8012.64,152.418 8134.23,246.172 8151.37,378.793C8151.37,378.793 8151.37,378.793 8151.37,378.794C8152.56,388.02 8159.86,395.262 8169.1,396.382C8260.52,407.397 8331.44,485.33 8331.44,579.698C8331.44,681.632 8248.69,764.389 8146.75,764.389C8078.03,764.389 8018.02,726.774 7986.22,671.025C7977.7,655.987 7960.89,647.642 7943.77,649.948C7943.22,650.005 7942.68,650.076 7942.14,650.147C7926.25,652.2 7910.52,652.662 7895.11,651.657C7878.99,650.569 7863.66,658.755 7855.6,672.755C7823.63,727.919 7763.96,765.052 7695.68,765.052C7593.74,765.052 7510.99,682.294 7510.99,580.36C7510.99,496.869 7566.51,426.243 7642.62,403.418ZM7695.68,443.909C7770.99,443.909 7832.13,505.051 7832.13,580.36C7832.13,655.67 7770.99,716.811 7695.68,716.811C7620.37,716.811 7559.23,655.67 7559.23,580.36C7559.23,505.051 7620.37,443.909 7695.68,443.909ZM8141.46,484.945C8145.14,473.697 8153.36,464.503 8164.13,459.596C8174.9,454.69 8187.23,454.519 8198.13,459.125C8244.95,479.123 8277.79,525.605 8277.79,579.698C8277.79,652.021 8219.08,710.739 8146.75,710.739C8107.87,710.739 8072.93,693.771 8048.92,666.843C8040.97,657.984 8037.12,646.185 8038.32,634.343C8039.52,622.5 8045.64,611.709 8055.2,604.618C8095.5,574.731 8125.8,532.824 8141.46,484.945Z",
    style: {
      fill: "white"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.aae16b558ba385acd2c303440dfb8a01.svg";
export { ForwardRef as ReactComponent };